import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoSpace from 'eco-design/base/eco-space';
import EcoTitle from 'eco-design/base/eco-title';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.VS');
    
    // 表格数据
    const tableData = {
        experience: Array.from({ length: 7 }, (_, i) => ({
            deltaPro: t(`experience.deltaPro.item${i + 1}`),
            generator: t(`experience.generator.item${i + 1}`)
        })),
        costAndBillSaving: Array.from({ length: 3 }, (_, i) => ({
            deltaPro: t(`costAndBillSaving.deltaPro.item${i + 1}`),
            generator: t(`costAndBillSaving.generator.item${i + 1}`)
        }))
    };

    return (
        <div className={styles.comp} id="VS">
            <EcoSpace />
            <EcoTitle title={t('title')} />
            <EcoSpaceSmall />
            <div className="tableContainer">
                <table className="comparison-table">
                    <thead>
                        <tr>
                            <th className="comparison-table__th comparison-table__fixed-width"></th>
                            <th className="comparison-table__th comparison-table__header comparison-table__td--highlight">
                                <div className="comparison-table__header-content">
                                    <img
                                        src="https://websiteoss.ecoflow.com/upload/image/1745459423182/EcoFlow%20DELTA%20Pro%203.png"
                                        alt={t('deltaProTitle')}
                                        className="comparison-table__header-img"
                                    />
                                    <span>{t('deltaProTitle')}</span>
                                </div>
                            </th>
                            <th className="comparison-table__th comparison-table__header">
                                <div className="comparison-table__header-content">
                                    <img
                                        src="https://websiteoss.ecoflow.com/upload/image/1745459422993/Traditional%20Generator.png"
                                        alt={t('generatorTitle')}
                                        className="comparison-table__header-img comparison-table__header-img--small"
                                    />
                                    <span>{t('generatorTitle')}</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {/* Experience Section */}
                        {tableData.experience.map((item, index) => (
                            <tr key={`experience-${index}`}>
                                {index === 0 && (
                                    <th className="comparison-table__th comparison-table__fixed-width" rowSpan={7}>
                                        {t('experience.title')}
                                    </th>
                                )}
                                <td className="comparison-table__td comparison-table__td--highlight">{item.deltaPro}</td>
                                <td className="comparison-table__td">{item.generator}</td>
                            </tr>
                        ))}

                        {/* Cost and Bill Saving Section */}
                        {tableData.costAndBillSaving.map((item, index) => (
                            <tr key={`cost-${index}`}>
                                {index === 0 && (
                                    <th className="comparison-table__th comparison-table__fixed-width" rowSpan={3}>
                                        {t('costAndBillSaving.title')}
                                    </th>
                                )}
                                <td className="comparison-table__td comparison-table__td--highlight">{item.deltaPro}</td>
                                <td className="comparison-table__td">{item.generator}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}